import { PrimeIcons } from 'primereact/api';

import {
  RequestEventFragment,
  RequestEventType,
  RequestFilterInput,
  RequestIssueType,
} from '@/rtk-query.gql';
import { Me } from '@/types';

export const ISSUE_TYPES = [
  { id: RequestIssueType.CLIENT, name: 'Client Issue' },
  { id: RequestIssueType.REPORT, name: 'Data Request' },
];

export const ICONS: Record<RequestEventType, string> = {
  [RequestEventType.APPROVED]: PrimeIcons.EYE,
  [RequestEventType.COMMENT]: '',
  [RequestEventType.COMPLETED]: PrimeIcons.CHECK,
  [RequestEventType.DENIED]: PrimeIcons.TIMES,
  [RequestEventType.IN_PROGRESS]: PrimeIcons.PLUS,
};

export const IT_DEPARTMENT = 'IT Department';

export type CreateIssueManagerInput = {
  adUserId: string | null;
  issueType: RequestIssueType | null;
};

export const TYPE_OPTIONS = Object.keys(RequestIssueType);

export const getMyRequestsVariables = (
  adUserId: string,
  page: number,
  pageSize: number,
) => ({
  skip: page * pageSize,
  take: pageSize,
  where: {
    or: [
      { requestorId: { eq: adUserId } },
      { itIssue: { sponsorId: { eq: adUserId } } },
      {
        events: { some: { authorAdUserId: { eq: adUserId } } },
      },
      {
        subscriptions: { some: { adUserId: { eq: adUserId } } },
      },
    ],
  } as RequestFilterInput,
});

export const getAllRequestsVariables = (me: Me) => ({
  skip: PAGE * PAGE_SIZE,
  take: PAGE_SIZE,
  where: {
    type: { in: me?.issueManagerTypes ?? [] },
  } satisfies RequestFilterInput,
});

export const PAGE = 0;
export const PAGE_SIZE = 100;

export type Request = {
  id: number;
  type: string;
  events: RequestEventFragment[];
};
